import { fixEndDate, fixStartDate, formatCurrency, formatString, objectEditor, staticItemsSource } from "@eusoft/webapp-ui";
import { contentInfo } from "@eusoft/webapp-ui/abstraction/IContent";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { ReportViewContent, type IReportViewOptions, type RowFields } from "./ReportViewContent";
import { Authorize } from "../../services/Authorize";
import { context } from "../../services/Context";
import { executeAsync } from "../../services/DataService";
import { WithContext } from "../../services/WithContext";
import type { IWalletsReport, IWalletsReportRow } from "../../entities/Commands";
import { registerComponent } from "@eusoft/webapp-core/Component";

export class WalletReportPage extends ReportViewContent<IWalletsReport, IWalletsReportRow> {

    constructor() {

        super();

        this.init(WalletReportPage, {
            title: "wallet-report", 

            rowHeader: a => a.salePoint?.name,

            prepareFilter: filter => ({
                ...filter,
                saleCircuitId: context.saleCircuit?.id,
                toDate: fixEndDate(filter.toDate as Date),
                fromDate: fixStartDate(filter.fromDate as Date),

            }),

            rowFieldLabelPrefix: "wr-",

            rowFields: {
                "totalCreated": {

                },
                "totalActiveCards": {

                }, 
                "totalActiveCardsWithBalance": {

                },
                "totalTransactions": {

                },
                "totalCharged": {
                    format: formatCurrency,
                },
                "totalBuy": {
                    format: formatCurrency,
                },
                "totalRefunded": {
                    format: formatCurrency,
                },
                "totalReset": {
                    format: formatCurrency,
                },
                "totalBalance": {
                    format: formatCurrency,
                },
            } satisfies RowFields<IWalletsReportRow>,

            filterEditor: objectEditor<IWalletsReport>(bld => <>
                {bld.date(a => a.fromDate as Date, {
                    label: "from-date-art",
     
                })}
                {bld.date(a => a.toDate as Date, {
                    label: "to-date-art",
                })}
                {bld.singleSelector(a => a.groupBy, {
                    editor: {
                        emptyItem: formatString("[no-group]"),
                        itemsSource: staticItemsSource(["sale-point", "SalePoint"])
                    }
                })}
                {bld.boolean(a => a.excludeGifts, {

                })}
            </>, {
                commitMode: "manual",
                style: "vertical",
                inputField: { style: "filled" },
            })
        } as IReportViewOptions<IWalletsReport, IWalletsReportRow>);
    }

    override async queryAsync(filter: IWalletsReport) {
        const res = await executeAsync("WalletsReport", filter);
        return res.rows;
    }

    static override info = contentInfo({
        name: "wallet-report",
        route: "/reports/wallet",
        icon: <MaterialIcon style="green" name="wallet" />,
        features: [ 
            Authorize(a => a.businessAccount().resource("SaleCircuit", "admin")),
            WithContext("sale-circuit")
        ],
        factory: () => new WalletReportPage()
    });
}

registerComponent(WalletReportPage, "WalletReportPage");
